export type UserType = (typeof USER_TYPES)[keyof typeof USER_TYPES];

export const USER_TYPES = {
  INDIVIDUAL: 'individual',
  AGENCY: 'agency',
  BUSINESS: 'business',
} as const;
